import LayoutReducer from 'store/layout/reducers';

export default LayoutReducer;
